import request from "@/utils/request";

export function createSubAcc(params) {
  return request({
    url: `/ntocc-basic-api/shipment/createSubAcc`,
    method: "post",
    data: params
  });
}

export function subList(query) {
  return request({
    url: "/ntocc-basic-api/shipment/subList",
    method: "get",
    params: query
  });
}

export function deleteShipment(query) {
  return request({
    url: `/ntocc-basic-api/shipment`,
    method: "delete",
    params: query
  });
}

export function editSubAcc(params) {
  return request({
    url: `/ntocc-basic-api/shipment/editSubAcc`,
    method: "post",
    data: params
  });
}

// 更新支付权限
export function updatePayPermission(params) {
  return request({
    url: `/ntocc-basic-api/shipment/updatePayPermission`,
    method: "post",
    data: params
  });
}

// 更新子公司预付权限
export function updateSubShowStatus(params) {
  return request({
    url: `/ntocc-basic-api/shipment/updateSubShowStatus`,
    method: "post",
    data: params
  });
}

export function bindSubParty(params) {
  return request({
    url: `/ntocc-basic-api/shipmentCompanyParty/bindSubParty`,
    method: "post",
    data: params
  });
}
